import styled from '@emotion/styled';
import { Checkbox } from '@hotjar/hotsauce';

export const FilterListItem = styled(Checkbox)`
  margin-bottom: 0;
  text-transform: initial;
`;
